import { sharePointInternalFileName, sharePointInternalTitleName } from "../config/constants";
import { FileMetaData } from "../interfaces/props/FileMetaData";
import { LocalizationModule } from "../../../utilities/LocalizationModule";
import { titleIsEmpty, titleMatchesPlaceholder } from "../helpers/titleMetadata";

export class BasePersistor {
  protected hasValidValue = (value: string | any[]) => {
    if (Array.isArray(value) && !value.length) {
      return false;
    }

    return value;
  };

  protected getSavingDirectory = (directory: string, folderName: string) => {
    let IsNotSavingInFolder = !folderName;
    return IsNotSavingInFolder
      ? directory
      : `${!directory ? "" : directory + "/"}${folderName}`;
  };

  protected getInputValue = (inputValue: any) => {
    return !(inputValue === 0) && (!inputValue || (Array.isArray(inputValue) && !inputValue?.length)) ? undefined : inputValue;
  }

  // All localized variants of the "Title auto-set" placeholder. Cached so the
  // lookup runs once per persistor instance regardless of how many files save.
  private titleAutoSetVariants: string[] = LocalizationModule.getTitleAutoSetVariants();

  // Single serialization choke point for a file's metadata. Every save path
  // (Office, Outlook, file-system) routes through this, guaranteeing the Title
  // column defaults to the Name (FileLeafRef) value whenever the user has not
  // supplied an explicit Title. A Title the user typed is preserved untouched.
  protected mapFileMetadata = (file: FileMetaData) => {
    // Authoritative final name: prefer the Name field the user entered/renamed,
    // fall back to the file-level name carried on the FileMetaData itself.
    const nameField = file.metaData?.find(input => input?.internalName === sharePointInternalFileName);
    const resolvedName = this.getInputValue(nameField?.value) ?? file.name;

    return file.metaData?.map(input => {
      let value = this.getInputValue(input?.value);

      if (input?.internalName === sharePointInternalTitleName) {
        if (titleMatchesPlaceholder(value, this.titleAutoSetVariants)) {
          // Never persist the UI placeholder: default to the name, else clear it.
          value = resolvedName || undefined;
        } else if (titleIsEmpty(value) && resolvedName) {
          // No explicit Title supplied: default to the Name field value.
          value = resolvedName;
        }
      }

      return { type: input?.type, internalName: input?.internalName, value };
    });
  };
}
